import { render } from "./SupplyRequestDash.vue?vue&type=template&id=d8f26950"
import script from "./SupplyRequestDash.vue?vue&type=script&lang=js"
export * from "./SupplyRequestDash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__